<template>
  <qtm-content-block :collapsed="collapsed" collapsible title="Comment">
    <qtm-textarea
      v-bind="$attrs"
      auto-grow
      data-test="comment-input"
      rows="1"
    />
  </qtm-content-block>
</template>

<script setup>
defineProps({
  collapsed: {
    type: Boolean,
    default: false,
  },
})
</script>
